import { render, staticRenderFns } from "./AutoTextEditor.vue?vue&type=template&id=f8ed53a6&"
import script from "./AutoTextEditor.vue?vue&type=script&lang=js&"
export * from "./AutoTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./AutoTextEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports